import { Injectable } from '@angular/core';
import { FeatureFlagsRulesService, Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { SaleAdvanceAdjustmentRepositoryBase } from '@skylab-shared/business';
import { ClientRepository } from '../client/client.repo';
import { ProductRepository } from '../product/product.repo';
export { SaleAdvanceAdjustmentRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(SaleAdvanceAdjustmentRepositoryBase)
export class SaleAdvanceAdjustmentRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
        clientRepository: ClientRepository,
        productRepository: ProductRepository,
        queryBus: QueryBus,
        featureFlagsRulesService: FeatureFlagsRulesService
    ) { }
}
